import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.authoring');
import { OnInit, OnDestroy, ElementRef, HostListener } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-authoring',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.authoring/view.scss */
:host {
  display: block;
  min-height: 100%;
  height: 100%;
}

.workspace-error {
  margin: 16px 24px;
}

.navigation-progress {
  position: absolute;
  inset: 0 12px auto;
  height: 2px;
  overflow: hidden;
  border-radius: 2px;
}

.navigation-progress::after {
  content: "";
  display: block;
  width: 35%;
  height: 100%;
  background: var(--ui-nav-focus);
  animation: navigation-progress 1.2s ease-in-out infinite;
}

@keyframes navigation-progress {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(290%);
  }
}
.skip-link {
  position: fixed;
  top: 12px;
  left: 16px;
  z-index: 1000;
  padding: 12px 18px;
  background: var(--ui-accent);
  color: var(--ui-on-accent);
  border-radius: 9px;
  font-size: 16px;
  font-weight: 650;
  transform: translateY(calc(-100% - 20px));
  text-decoration: none;
}

.skip-link:focus {
  transform: translateY(0);
  outline: 3px solid var(--ui-ink);
  outline-offset: 3px;
}

#workspace-content:focus {
  outline: none;
}

@media (max-width: 960px) {
  .navigation-progress {
    inset: auto 0 0;
    border-radius: 0;
  }
  .workspace-error {
    margin: 12px 16px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .navigation-progress::after {
    animation: none;
    width: 100%;
  }
}`],
})
export class LayoutAuthoringComponent implements OnInit, OnDestroy {
    page: any = null; mobileNav = false; loggingOut = false; navigating = false; error = '';
    private routerSub: any; private loadingTimer: any; private focusTimer: any;
    private focusAfterNavigation = false;
    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router,@Inject( ElementRef<HTMLElement>)  private host: ElementRef<HTMLElement>) {}
    get workspace() { return !!this.page?.workspacePage; }
    get user() { return this.page?.data?.user || this.page?.user || this.page?.sessionUser; }
    async ngOnInit() {
        await this.service.init();
        this.routerSub = this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                clearTimeout(this.loadingTimer);
                this.loadingTimer = setTimeout(() => { this.navigating = true; this.service.render(); }, 150);
            }
            if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
                clearTimeout(this.loadingTimer); this.navigating = false;
                if (event instanceof NavigationError) this.error = '화면을 열지 못했습니다. 메뉴를 다시 선택해 주세요.';
                this.service.render();
                if (event instanceof NavigationEnd && this.focusAfterNavigation) {
                    this.focusAfterNavigation = false;
                    clearTimeout(this.focusTimer);
                    this.focusTimer = setTimeout(() => {
                        const main = this.host.nativeElement.querySelector('#workspace-content');
                        if (main && !main.contains(document.activeElement)) this.focusContent();
                    }, 0);
                }
                if (event instanceof NavigationCancel || event instanceof NavigationError) this.focusAfterNavigation = false;
            }
        });
    }
    ngOnDestroy() {
        this.routerSub?.unsubscribe(); clearTimeout(this.loadingTimer); clearTimeout(this.focusTimer);
    }
    activate(page: any) {
        this.focusAfterNavigation = !!this.page && this.page !== page && !!page?.workspacePage;
        this.page = page; this.mobileNav = false; this.error = '';
        this.service.render();
    }
    focusContent(event?: Event) {
        event?.preventDefault();
        const target = this.host.nativeElement.querySelector<HTMLElement>('#workspace-content h1, #workspace-content');
        const heading = this.host.nativeElement.querySelector<HTMLElement>('#workspace-content h1');
        const destination = heading || target;
        if (!destination) return;
        destination.setAttribute('tabindex', '-1');
        destination.focus({preventScroll: true});
        if (event) destination.scrollIntoView({block: 'start', behavior: 'instant' as ScrollBehavior});
    }
    navigate(target: string) {
        this.mobileNav = false; this.error = '';
        this.page?.scroll?.(target);
        this.service.render();
    }
    toggleNav() { this.mobileNav = !this.mobileNav; this.service.render(); }
    closeNav() {
        this.mobileNav = false; this.service.render();
        this.host.nativeElement.querySelector<HTMLElement>('#workspace-menu-toggle')?.focus({preventScroll:true});
    }
    @HostListener('document:keydown.escape', ['$event'])
    closeNavOnEscape(event: KeyboardEvent) {
        if (!this.mobileNav) return;
        event.preventDefault(); this.closeNav();
    }
    @HostListener('document:focusin', ['$event'])
    closeNavWhenFocusLeaves(event: FocusEvent) {
        if (!this.mobileNav) return;
        const header = this.host.nativeElement.querySelector('.workspace-topbar');
        if (header?.contains(event.target as Node)) return;
        this.mobileNav = false;
        this.service.render();
    }
    pageLabel() {
        const url = this.router.url || '/';
        const path = url.split(/[?#]/)[0];
        if (path === '/admin') {
            const tab = new URLSearchParams((url.split('?')[1] || '').split('#')[0]).get('tab');
            return {users:'사용자 및 권한',reviews:'검토 및 평가 관리'}[tab || ''] || '운영 현황';
        }
        if (path === '/datasets' && this.user?.role === 'reviewer') return 'QA 검수';
        if (path === '/' && this.user?.role === 'reviewer') return '홈';
        if (path === '/') return url.split('#')[1] === 'jobs' ? '작업 현황' : '홈';
        return {'/sources':'문헌 관리','/datasets':'데이터셋','/knowledge-graph':'지식 관리','/knowledge-map':'지식 관리','/dpo':'선호도 평가'}[path] || '작업 공간';
    }
    roleLabel() {
        if (this.user?.status !== 'active') return '승인 대기';
        return {admin:'시스템 관리자',researcher:'연구 담당자',reviewer:'검수·평가자',external:'외부평가자'}[this.user?.role] || '사용자';
    }
    async logout() {
        if (this.loggingOut) return;
        const canLeave = typeof this.page?.canDeactivate === 'function'
            ? this.page.canDeactivate.bind(this.page) : this.page?.leave?.bind(this.page);
        if (canLeave && !(await canLeave())) return;
        this.loggingOut = true; this.error = ''; await this.service.render();
        try {
            const res = await wiz.app('page.access').call('logout', {csrf: this.page?.csrf});
            if (res.code !== 200) throw new Error();
            this.page?.afterLogout?.();
            await this.service.auth.init(); this.service.href('/access/login');
        } catch { this.error = '로그아웃하지 못했습니다. 다시 시도해 주세요.'; }
        this.loggingOut = false; await this.service.render();
    }
}

export default LayoutAuthoringComponent;